import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

export const useAuth0Callback = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const {
    data,
    isLoading: isLoadingData,
    error: errorData,
    mutate,
  } = useMutation(
    ["auth0-callback"],
    async (token: string) => {
      const response = await fetch(ENDPOINTS.auth0_callback, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token,
        }),
      });

      return handleResponse(response);
    },
    {
      onSuccess: ({ access_token, user }) => {
        auth?.login(access_token, user);
        navigate("/");
      },
    },
  );

  return {
    data,
    isLoading: isLoadingData,
    error: errorData,
    createUser: mutate,
  };
};
